export default "__VITE_ASSET__DvJ0Ihzh__"